import React, {Component} from "react";

import HomePlayerGameSessionCard from "./home-player-game-session-card.js";


import {createPlayerGameSessionAsync} from "../../../modules/player_game_session.js";


import {buildPlayGameUrl, buildSingleGameSessionURL} from "../../../services/game-session/game-session-service.js";
import Constants from '../../../constants/constants'

class HomeSessionsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            session_selected: false
        };
    }

    async sessionSelected(sessionID) {
        let {player, token, selected_circle_member} = this.props;
        let {session_selected} = this.state;

        if (session_selected) {
            return;
        }

        this.setState({session_selected: sessionID});


        let url = "";



        if (sessionID !== -1) {
            let creationResponse = await createPlayerGameSessionAsync(player.id, token, sessionID);
            if (creationResponse && creationResponse.data && creationResponse.data.success) {
                let url = buildPlayGameUrl(creationResponse.data.player_game_session_id, token, Constants.getPlayContentUrl());
                url += "&home_play=1";
        
                if (selected_circle_member.id !== -1) {
                    url += "&circle_member_id=" + selected_circle_member.id;
                }
        
                window.location = url;
            }
            else {
                alert("Something went wrong... please try again later");
                this.setState({session_selected: false});
            }
        }
        else { 
            url = buildSingleGameSessionURL(token, Constants.getPlayContentUrl());

            url += "&home_play=1";

            if (selected_circle_member.id !== -1) {
                url += "&circle_member_id=" + selected_circle_member.id;
            }

            window.location = url;
        }
       
    }

    printHomeSessions (homeSessions) {
        let {token, selected_circle_member} = this.props;
        let {session_selected} = this.state;
        let freePlaySession = {
            name: "Free Play",
            game_session_id: -1
        };

        let className = "home_sessions_page_session_cards_grid";
        if (homeSessions.length < 2) {
            className = "home_sessions_page_session_cards_centered";
        }


        return (
            <div className={className}>
                {homeSessions.map((homeSession) => {
                    return (<HomePlayerGameSessionCard session={homeSession} token={token} selected_circle_member={selected_circle_member} session_selected={session_selected} on_click={this.sessionSelected.bind(this)}/>);
                })
                }
                <HomePlayerGameSessionCard session={freePlaySession} token={token} selected_circle_member={selected_circle_member} session_selected={session_selected} on_click={this.sessionSelected.bind(this)}/>
            </div>
        )
        
        

        

        
    }
    render() {
        let {sessions, selected_circle_member, clear_circle_member, player} = this.props;


        let gotHomeSessions = true;


        let titleText = "Select a session to start playing!";
        let subTitleText = "";
        if (selected_circle_member.id !== -1) {
            titleText = "Hey " + selected_circle_member.first_name + ", ready for some fun and practice with " + player.home_user.first_name + "?";
            subTitleText = "Choose one of the sessions below";
        }


        return (
            <div className='home_player_dashboard_home_sessions'>
                
                <div className='home_player_dashboard_home_sessions_title'>{titleText}<br/>{subTitleText}</div>
                <button className='back_to_circle_member_selection' onClick={clear_circle_member}>Go Back</button>
                <div className='home_player_dashboard_home_sessions_container'>
                    {gotHomeSessions && this.printHomeSessions(sessions)}
                </div>
                
            </div>
        );
        
    }
}

export default HomeSessionsPage;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/home-sessions-page.js